const navbarScroll = () => {
	const navbar = document.querySelector(".header--js");
	window.addEventListener("scroll", function () {
		if (window.scrollY >= 100) {
			navbar.classList.add("header--scroll");
		} else if (window.scrollY <= 100) {
			navbar.classList.remove("header--scroll");
		}
	});
};

export default navbarScroll;
